import { Box as MuiBox } from "@mui/material";
import { DataGridPro as MuiDataGrid } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { getTableColumnHeaders, tableStyles } from "./CSVTableConfig";
import { LoadingGridOverlay, NoRowsGridOverlay } from "common";

const CSVTable = ({ inputRecords, csvType }) => {
  const { t } = useTranslation();

  const columnConfig = getTableColumnHeaders({ t, csvType });

  const NoCSVTableOverlay = () => (
    <NoRowsGridOverlay message={t("csv.table.noRows")} />
  );

  return (
    <MuiBox id="csv-table-box" sx={{ width: "100%" }}>
      <MuiDataGrid
        slots={{
          loadingOverlay: LoadingGridOverlay,
          noRowsOverlay: NoCSVTableOverlay,
        }}
        autoHeight
        disableColumnMenu
        disableColumnResize
        disableColumnReorder
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableMultipleColumnsSorting
        disableRowSelectionOnClick
        pagination
        onPaginationModelChange={() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }}
        rows={inputRecords}
        getRowId={(row) =>
          row.id || row["Protocol Number"] || row["Protocol No"]
        }
        columns={columnConfig}
        initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
        pageSizeOptions={[20, 50, 100, 500]}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd"
        }
        getRowHeight={() => "auto"}
        sx={tableStyles}
      />
    </MuiBox>
  );
};

export default CSVTable;
